import { render, staticRenderFns } from "./RuleModal.vue?vue&type=template&id=5e9c80d2&scoped=true&"
import script from "./RuleModal.vue?vue&type=script&lang=js&"
export * from "./RuleModal.vue?vue&type=script&lang=js&"
import style0 from "./RuleModal.vue?vue&type=style&index=0&id=5e9c80d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9c80d2",
  null
  
)

export default component.exports